<template>
  <div
    class="sidebar"
    :data-color="activeColor"
    :data-image="backgroundImage"
    :data-background-color="backgroundColor"
    :style="sidebarStyle"
  >
    <div class="logo">
      <a  class="simple-text logo-mini" target="_blank" @click="goToHome">
        <div class="logo-img" >
          <img :src="user.avatar ? user.avatar :getLocalLog()?getLocalLog(): './img/vue-logo.png'" style="width: 24px; height: 24px;" />
        </div>
      </a>
      <a href="#" class="simple-text logo-normal" target="_blank">
        <template v-if="$route.meta.rtlActive">{{ rtlTitle }}</template>
        <template v-else>{{ title }}</template>
      </a>
      <div class="navbar-minimize">
        <md-button
          id="minimizeSidebar"
          class="md-round md-just-icon md-transparent"
          @click="minimizeSidebar"
        >
          <i class="material-icons text_align-center visible-on-sidebar-regular">more_vert</i>
          <i class="material-icons design_bullet-list-67 visible-on-sidebar-mini">view_list</i>
        </md-button>
      </div>
    </div>
    <div class="sidebar-wrapper" ref="sidebarScrollArea">
      <slot></slot>
      <md-list class="nav">
        <slot name="links">
          <sidebar-item v-for="(link, index) in sidebarLinks" :key="index" :link="link">
            <sidebar-item
              v-for="(subLink, subIndex) in link.children"
              :key="`${subIndex}_${index}`"
              :link="subLink"
            >
            </sidebar-item>
          </sidebar-item>
        </slot>
      </md-list>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name: 'sidebar',
  props: {
    title: {
      type: String,
      default: '元学',
    },
    rtlTitle: {
      type: String,
      default: 'توقيت الإبداعية',
    },
    activeColor: {
      type: String,
      default: 'green',
      validator: value => {
        let acceptedValues = ['', 'purple', 'azure', 'green', 'orange', 'danger', 'rose'];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    backgroundImage: {
      type: String,
      default: './img/sidebar-2.jpg',
    },
    backgroundColor: {
      type: String,
      default: 'black',
      validator: value => {
        let acceptedValues = ['', 'black', 'white', 'red'];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    logo: {
      type: String,
      default: './img/vue-logo.png',
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
    },
    autoClose: {
      type: Boolean,
      default: true,
    },
  },
  provide() {
    return {
      autoClose: this.autoClose,
    };
  },
  methods: {
    goToHome(){
      this.$router.push('/dashboard')
    },
    getLocalLog(){
         if(window.localStorage.getItem('USER_INFO')){
          let data = JSON.parse(window.localStorage.getItem('USER_INFO'))
          if(data&&data.user&&data.user.avatar){
            return data.user.avatar
          }else{
            return ''
          }
         }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
  },
  computed: {
    ...mapGetters(['user']),
    sidebarStyle() {
      return {
        backgroundImage: `url(${this.backgroundImage})`,
      };
    },
    userData() {
      this.$store.state.user;
    },
  },
  watch: {
    'this.$store.state.user': {
      deep: true,
      handler: function (val) {
      },
    },
    user(mews){
      // console.log()

    }
  },
  mounted() {
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  },
};
</script>
<style>
@media (min-width: 992px) {
  .navbar-search-form-mobile,
  .nav-mobile-menu {
    display: none;
  }
}
</style>
